module.exports = __webpack_public_path__ + "static/media/rica.38e6d3fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/rica.jpg
// module id = 725
// module chunks = 0